import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClue = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 200 200",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M125.4,20c-30.1,0-54.6,24.4-54.6,54.4c0,10.5,3,20.2,8.1,28.5L23.8,158c-5,5-5,13.2,0,18.2l0.1,0.1c5,5,13.2,5,18.2,0 l55.3-55.2c8.2,4.9,17.8,7.7,28.1,7.7c30.1,0,54.6-24.4,54.6-54.4S155.6,20,125.4,20z M125.7,105.1c-17,0-30.8-13.7-30.8-30.7 c0-16.9,13.8-30.7,30.8-30.7s30.8,13.7,30.8,30.7C156.5,91.4,142.7,105.1,125.7,105.1z" })
});
export default SvgClue;
